export const Text = [
    "As a top-rated JavaScript development company in India, IStellar strives to develop reliable, custom and fully-functional Angular web and mobile applications for businesses of all shapes and sizes. Our Angular developer experts creating flexible, reusable and highly scalable codes to improve user experience. We specialize in Agile development process to ensure the fast-paced development of powerful Angular apps in quick time.",
    "With a bunch of skilled experts and effective technical resources in angular, we offers business-ready capabilities. This comprises of business analysis, design, quality assurance, project management and architecture. Also we give special focus on user experience and we ensure that your Angular app is designed to delight! We built some inspiring interfaces in Angular and if you are looking for a Angular experts for hiring, your search ends here.",
  
]

export const Text1 = [
    "IStellar is one of the earlier adopters of Angular and we offer dedicated Angular development services with the most advanced tools and techniques for on-time project delivery. Our developers follows a specific method for satisfying the needs of our clients. We have a strong focus on UI/UX designs and provide flexible delivery models and engagement with the clients to meet diverse business requirements. You can expect quality deliverables at an affordable rate from our company. Our excellent track record in Angular shows our uniqueness in the industry.",
    "Our Development team always stay updated to the latest technologies, tools and updates in Angular Framework. We follow Agile development process to ensure the fast-paced development of powerful Angular apps in quick time. We provide regular reporting facility to our clients daily. We used GIT in most of our projects to easily maintain the source code versions & deployments. We develop apps using high coding standards, research, proper planning and we deliver fast, efficient tested quality work.",
   
   
]


export const list1=[
    {
    ul: [
        {li: "ReactJS development",
        path: "services/reactjs-development"},
        {li: "VueJS development",
        path: "/services/vuejs-development"},
        {li: "AngularJS development",
        path: "/services/angular-development"},
        {li: "NodeJS API development",
        path: "/services/nodejs-development"},
        {li: "D3.JS Data Visualization",
        path: "/"},
        {li: "React Native Mobile App Development",
        path: "/services/reactjs-development"},
    ]
}
]

export const list2=[
    "Finance",
    "Travel",
    "Education",
    "Telecom",
]

export const AngularServices = [
    {
        h6: "Angular Web Application Development",
        para: "IStellar developers highly skilled to deliver top quality Angular application development services to all business requirements. Empowering the complex and sophisticated one-page applications, it won't let you stuck due to performance issues. We deliver well-structured apps by leveraging the latest technologies like AR, VR, IoT, Blockchain."
    }, {
        h6: "Angular Custom Application Development",
        para: "Through our custom Angular Application Development services we allow you to create the most appropriate solution for your business context. We build functional UI/UX designs for enhanced user experience contributing to increase customer loyalty."
    }, {
        h6: "Angular Enterprise Application Development",
        para: "Our knowledge of Angular helps deliver applications for business enterprises. Our developers provide end-to-end enterprise application development services from initial planning to final Angular app deployment at your servers."
    }, {
        h6: "Angular Maintenance & Support Services",
        para: "Our extensive support & maintenance for Angular development is one of the top reason for our clients chose us over other Angular development company. Interactivity builds customer loyalty to your company."
    }, {
        h6: "Angular QA and Testing",
        para: "Our Angular QA team provides some reasonable efforts for the testing app. We do unit testing(Jasmine, Karma) while development and add end to end test(Protractor) cases based on our client needs. We ensure error-free and seamless functioning of your app."
    },  
]
export const Angular1 = [
    "angular1",
]
export const Angular2 = [
    "angular2",
]